import { z } from 'zod';

export const WINDOW_OPTIONS = [
    { label: '7d', days: 7 },
    { label: '30d', days: 30 },
    { label: '90d', days: 90 },
    { label: 'All time', days: 0 },
] as const;

export const WINDOW_DAYS_SCHEMA = z.union([
    z.literal(0),
    z.literal(7),
    z.literal(30),
    z.literal(90),
]);

export const DATA_SOURCE_SCHEMA = z.enum([
    'wellsky',
    'axiscare',
    'hhaexchange',
]);

export type WindowDays = z.infer<typeof WINDOW_DAYS_SCHEMA>;
export type ShiftAssignmentDataSource = z.infer<typeof DATA_SOURCE_SCHEMA>;

export const DEFAULT_WINDOW_DAYS: WindowDays = 30;
export const FAILURES_PER_PAGE = 100;
export const DETAILS_SECTION_ID = 'shift-assignment-health-details';

export type ShiftAssignmentOrganization = {
    readonly id: string;
    readonly name: string;
};
